/**
 * 自動入札のルールタイプ
 */
const bidRuleType = {
  /**
   * 最適化: 1
   */
  Optimize: 1,
  /**
   * 配信ペース: 2
   */
  Delivery: 2,
  /**
   * ターゲット追加: 3
   */
  Target: 3,
  /**
   * 日予算最適化: 4
   */
  Budget: 4
}

export default bidRuleType
